<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    .flash-message {
        position: fixed;
        width: calc(100% - 1rem);
        left: 50%;
        top: 5.313rem;
        transform: translate(-50%);
        z-index: 999999;
        border-radius: 0.375rem;
        max-width: 53rem;

        &.is-info {
            background-color: #F5CF05;
        }

        &.is-success {
            background-color: #5DBE7B;
        }

        &.is-warning {
            background-color: #FFAE00;
        }

        &.is-error {
            background-color: #E20B0B;
        }
    }

    .flash-message-content {
        font-family: 'Raleway', sans-serif;
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        padding: 1.375rem 4.375rem;
        color: $white;
    }

    .flash-message-button {
        width: 2.5rem;
        height: 2.5rem;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 3px;

        &.is-badge {
            right: auto;
            left: 15px;
            background-color: rgba($white, 0.2);
        }

        &:not(.is-badge) {
            transition: background-color .2s;

            &:hover {
                background-color: rgba($white, 0.2);
            }
        }
    }

    .flash-message-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1rem;
        height: 1rem;
    }
</style>

<template>
    <div class="flash-message" :class="`is-${data.type}`">
        <div class="flash-message-button is-badge">
            <div class="flash-message-icon">
                <BaseIcon :icon="data.type + '-message'"/>
            </div>
        </div>

        <div class="flash-message-content" v-html="data.message"></div>

        <a class="flash-message-button" @click="close">
            <div class="flash-message-icon">
                <BaseIcon icon="cross"/>
            </div>
        </a>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import BaseIcon from './BaseIcon'

    export default {
        components: {
           BaseIcon
        },

        computed: {
            ...mapState({
                data: state => state.flashMessage.data
            })
        },

        methods: {
            ...mapMutations([
                'flashMessageToggle'
            ]),

            close () {
                this.flashMessageToggle()
            }
        }
    }
</script>
